import { useContext, useMemo, useState } from "react";
import { TeamsFxContext } from "./Context";
import { useReduxDispatch } from "../redux/hooks/hooks";
import TicketGrid from "./TicketGrid";
import { getUserManager } from "../redux/store";
import { userSignedOut } from "redux-oidc-2";
import HeaderBar from "./HeaderBar";
import { userApi } from "../redux/api/userApi";
import { useSearchParams } from "react-router-dom";
import './Tab.scss';
import { ticketApi } from "../redux/api/ticketApi";
import { useTabConfig } from "./hooks/useTabConfig";
import TicketCardList from "./TicketCardList";
import { OpenTicketProps } from "../types/Ticket/OpenTicketProps";
import { Field } from "@fluentui/react-components";
import { ColumnList } from "./ColumnList";
import GroupList from "./GroupList";
import { getTicketState } from "../util/getTicketState";
import { accountApi } from "../redux/api/accountApi";
import { SimpleSpinny } from "./Spinny";
import FilterInfo from "./FilterInfo";



export default function Tab() {
  const [params] = useSearchParams();
  const { data: profile, isLoading: loading } = userApi.useGetProfileQuery();
  const dispatch = useReduxDispatch();
  const { themeString } = useContext(TeamsFxContext);
  const { data: hostConfig } = accountApi.useGetHostConfigQuery(profile?.Tenant_Uid || "", { skip: !profile?.Tenant_Uid });
  const tabConfig = useTabConfig();
  const { data: list, isLoading: listLoading } = ticketApi.useGetTicketListQuery({ myTicketsOnly: tabConfig.myCallsOnly, companyIds: tabConfig.clientIds, projectIds: tabConfig.projectIds, assignedToIds: tabConfig.queueIds.map(String), queueIds: tabConfig.queueIds, statusIds: tabConfig.statusIds, priorityIds: tabConfig.priorityIds, assignedTeamIds: tabConfig.teamIds } as OpenTicketProps, { skip: !profile, pollingInterval: 60000 });
  const [filter, setFilter] = useState<string>("");
  const { data: gridState, isLoading: gridStateLoading } = userApi.useGetSettingQuery(146);

  const filteredListItems = useMemo(() => {
    //if (!filter) return items;
    var filtered = (list || []).map(item => {
      return {
        ...item,
        State: getTicketState({ homeTicket: item, newCallThresholdMins: hostConfig?.New_Call_Mins || 0, now: new Date() })
      }
    });
    if (filter) {
      filtered = filtered.filter(item =>
        Object.values(item).some(value =>
          value?.toString().toLowerCase().includes(filter.toLowerCase())
        )
      );
    }
    //Filter by state
    if (tabConfig.states && tabConfig.states.length > 0) {
      filtered = filtered.filter(item => tabConfig.states!.includes(item.State?.toLowerCase() ?? ""));
    }
    return filtered;
  }, [list, filter]);

  const logout = () => {
    // Clear user from oidc-client-ts storage and redux-oidc-2 state
    getUserManager().removeUser().then(() => {
      //Clear the tenant ID cookie on logout to prevent auto sign in on iOS
      document.cookie = `revTenantId=; SameSite=None; secure=true; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;

      console.log("User logged out ,cookie gone!.", document.cookie.split(";"));
      dispatch(userSignedOut());


    }).catch((err) => {
      console.error("Logout failed:", err);
    });
  }

  if (loading || listLoading || gridStateLoading) {
    return (
      <SimpleSpinny text={`Loading...`} />
    );

  }


  let themeClass = themeString === "default" ? "light" : themeString === "dark" ? "dark" : "contrast"
  return (
    <div
      className={`${themeClass} d-flex flex-column vh-100 overflow-hidden vw-100 `}
    >
      {/* keys = {Array.from(params.keys()).join(", ")} */}
      <HeaderBar filter={filter} onfilterChange={(f) => setFilter(f)} onLogout={logout} fullSiteUrl="/revelation_logo.png" userName={profile ? profile?.F_Name + ' ' + profile?.L_Name : '...'} avatarSrc={profile?.Profile_Image_Url} />
      {/* tabConfig = {JSON.stringify(tabConfig)}<br /> */}
      <Field className="d-flex justify-content-between p-1"  >
        {tabConfig.description ? <h5 className="subheader">Open {profile?.Phrases?.CallPhrase || "Ticket"}s for <i className="text-info">{tabConfig.description}</i>: {filteredListItems?.length}</h5> : <h5 className="header">{tabConfig.myCallsOnly ? `Your ${profile?.Phrases?.CallPhrase || "Ticket"}s` : `Open  ${profile?.Phrases?.CallPhrase || "Ticket"}s`}: {filteredListItems?.length}</h5>}
        <FilterInfo />
        <div className="d-flex w-auto justify-content-end flex-grow-1 flex-shrink-1" style={{ width: "80%" }} >
          <ColumnList />
          <GroupList />
          {/* <SearchBox className="flex-grow-1" placeholder="filter" value={filter} onChange={(e, newValue) => setFilter(newValue?.value || "")} /> */}
        </div>
      </Field>
      <div className="d-flex flex-column position-relative grid-container vh-100 overflow-hidden">
        <div className="ticket-grid-container fullscreen">
          <TicketGrid list={filteredListItems ?? []} />
        </div>

        <div className="ticket-list-contrainer fullscreen">
          <TicketCardList list={filteredListItems ?? []} />
        </div>
      </div>
    </div>
  );
}
